module.exports = __webpack_public_path__ + "img/90sheji_linggan_13332287@2x.ebadc6b6.png";